import React from "react"

const WidgetHeaderButton = ({
    additionalClasses,
    isSecondary,
    children,
    ...rest
}) => (
    <button
        className={`btn btn-${
            isSecondary ? "secondary" : "primary"
        } widget-header-button ${additionalClasses ? additionalClasses : ""}`}
        {...rest}
    >
        {children}
    </button>
)

export default WidgetHeaderButton
